/**
 * `DataValidation` is a utility object that provides methods for validating data.
 */
export const Validate: DataValidation = {
  isEmailValid: (email: string) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  },
  isUrlValid: (url: string) => {
    const urlRegex = /^(http|https):\/\/[^ "]+$/;
    return urlRegex.test(url);
  },
  isEmptyArray: (array?: any[]) => {
    return !array || array.length === 0;
  },
  isEmptyObject: (object?: Record<string, any>) => {
    return !object || Object.keys(object).length === 0;
  },
};

/**
 * `DataValidation` defines methods for validating data.
 */
export type DataValidation = {
  /**
   * Validates the given email address.
   *
   * @param email - The email address to be validated.
   * @returns `true` if the email address is valid, otherwise `false`.
   */
  isEmailValid: (email: string) => boolean;

  /**
   * Validates the given URL.
   *
   * @param url - The URL to be validated.
   * @returns `true` if the URL is valid, otherwise `false`.
   */
  isUrlValid: (url: string) => boolean;

  /**
   * Checks if the given object is empty, undefined, or null.
   *
   * @param array - An optional array to be checked.
   * @returns True if the array is empty or undefined, otherwise false.
   */
  isEmptyArray: (array?: any[]) => boolean;

  /**
   * Checks if the given object is empty, undefined, or null.
   *
   * @param object - An optional object to be checked.
   * @returns True if the object is empty, undefined, or null, otherwise false.
   */
  isEmptyObject: (object?: Record<string, any>) => boolean;
};
